export default __webpack_public_path__ + "static/video-placeholder-57874a435a06b9902575c640c791509e.jpg";